import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { AbstractCalendarEventsComponent } from '../../abstract-calendar-events.component';
import { CalendarComponentStateService } from '../../state/calendar-component.state-service';
import { PersonCalendarEvents } from '../../state/team-calendar';
import { CalendarDay, CalendarMonthDays } from '../../state/calendar';
import { HorizontalCalendarComponentStateService } from '../../state/horizontal-calendar-component.state-service';
import { ActionMenuItemConfig } from '@design/buttons/action-config';
import { forEach } from 'lodash';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-person-events-month-row]',
  templateUrl: './person-events-month-row.component.html',
  styleUrls: ['./person-events-month-row.component.scss'],
  providers: [{ provide: CalendarComponentStateService, useClass: HorizontalCalendarComponentStateService }],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonEventsMonthRowComponent extends AbstractCalendarEventsComponent {
  personName: string;
  calendarMonthDays$ = <BehaviorSubject<CalendarMonthDays>>this.componentStateService.calendarMonth$;

  @Input() interactive = true;
  @Input() rowSelected = false;
  @Input() actionMenuItems: ActionMenuItemConfig[];
  @Input() personCalendarEvents: PersonCalendarEvents;

  personCalendarMonthDays$ = this.calendarMonthDays$.pipe(
    map((dayMonth) => {
      let returnModel = [];
      dayMonth.forEach((day) => {
        returnModel.push({ ...day, ...this.personCalendarEvents });
      });
      return returnModel;
    })
  );

  @Input() set memberEvents(personCalendarEvents: PersonCalendarEvents) {
    this.personName = `${personCalendarEvents.forename} ${personCalendarEvents.surname}`;
    // nonWorkingDays need to be found first here, as holidays might span them, and there will be multiple events for the same date
    this.eventModels = []
      .concat(personCalendarEvents.nonWorkingDays)
      .concat(personCalendarEvents.requests)
      .concat(personCalendarEvents.allocatedHoliday)
      .concat(personCalendarEvents.sickDays ?? []);

    this.personCalendarEvents = personCalendarEvents;
  }

  getDayCss(day: CalendarDay | null): Record<string, boolean> {
    const classes = super.getDayCss(day);
    classes['non-interactive'] = !this.interactive;
    classes['row-selected'] = this.rowSelected;
    return classes;
  }
}
